<template>
  <div>
    <div class="header-info-panel">
      <div class="info-content">

        <!-- 第一行：时间 + 天气 -->
        <div class="row">
          <span class="label">时间：</span>
          <span class="value">{{ currentTime }}</span>

          <img src="../assets/sun.png" class="weather-icon"/>
          <span class="value">20℃ 阴</span>
        </div>

        <!-- 第二行：用户信息 -->
        <div class="row user-row">
          <span class="label">用户：</span>
          <span class="value">{{ userData.name }}</span>
          <span class="value role">（{{ userData.role }}）</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderInfoPanel',
  props: {
    userData: {
      type: Object,
      default: () => ({
        name: '管理员',
        role: '系统管理员'
      })
    }
  },
  data() {
    return {
      currentTime: '',
      timeInterval: null
    };
  },
  mounted() {
    this.startTimeUpdate();
  },
  beforeDestroy() {
    if (this.timeInterval) clearInterval(this.timeInterval);
  },
  methods: {
    startTimeUpdate() {
      this.updateTime();
      this.timeInterval = setInterval(() => this.updateTime(), 1000);
    },
    updateTime() {
      const now = new Date();
      this.currentTime = now.toLocaleString('zh-CN', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
    }
  }
};
</script>

<style scoped>
.header-info-panel {
  position: fixed;
  top: 1%;
  right: 1px;
  width: 220px;   /* 更宽一点适应双行 */
  z-index: 1000;
  color: white;
  font-size: 14px;
  line-height: 1.2;
  pointer-events: none;
}

.info-content {
  display: flex;
  flex-direction: column;

}

.row {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.label {
  color: #00F2F8;
  font-weight: bold;
}

.value {
  color: #ffffff;
}

.role {
  color: #00aaff;
}

.weather-icon {
  width: 18px;
  height: 18px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .header-info-panel {
    font-size: 12px;
    width: 200px;
  }
}

@media (max-width: 768px) {
  .header-info-panel {
    font-size: 10px;
    width: 180px;
  }
}
</style>
